import {
  getUserDetails,
  listSnapshots,
  createBackup,
  exportSnapshot,
  restoreSnapshot
} from "@/services/api/app/google/recovery/contact/contact";
import files from "@/store/app/google/recovery/contact/data-set/file";
import exports from "@/store/app/google/recovery/contact/exports";
import restores from "@/store/app/google/recovery/contact/restores";
import backups from "@/store/app/google/recovery/contact/backups";
import user from "@/store/app/google/recovery/drive/user";
import {
  connectAws,
  connectAzure, connectBox,
  connectDropbox, connectGoogle,
  connectGoogleCloud, connectMicrosoft,
  connectS3Compatible, deleteConnection, listConnection, listRegion, listRegionsGCP
} from "@/services/api/common/connection";

const defaultState = () => ({
  userMap: {},
  listRegions: {},
  listRegionsGcp: {}
});

export default {
  namespaced: true,
  actions: {
    getUserDetails({commit}, userId) {
      return getUserDetails(userId)
        .then(user => {
          commit('setUser', user);
          return user;
        })
    },
    createBackup({commit}, userId) {
      return createBackup(userId);
    },
    listSnapshots({commit}, {userId, date, dateTo}) {
      return listSnapshots({userId, date, dateTo});
    },
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '0'
      });
    },
    restoreSnapshot({}, data) {
      return restoreSnapshot(data);
    },
    connectAws({commit}, data) {
      return connectAws(data);
    },
    connectAzure({commit}, data) {
      return connectAzure(data);
    },
    connectS3Compatible({commit}, data) {
      return connectS3Compatible(data);
    },
    connectGoogleCloud({commit}, data) {
      return connectGoogleCloud(data);
    },
    connectDropbox({commit}, data) {
      return connectDropbox(data);
    },
    connectGoogle({commit}, data) {
      return connectGoogle(data);
    },
    connectMicrosoft({commit}, data) {
      return connectMicrosoft(data);
    },
    connectBox({commit}, data) {
      return connectBox(data);
    },
    listConnection({commit}, data) {
      return listConnection(data);
    },
    deleteConnection({commit, state}, {id}) {
      return deleteConnection(id)
    },
    listRegion({commit, state}) {

      return listRegion()
        .then(region => {
          commit('setRegion', region);
          return region;
        })
    },
    listRegionGCP({commit, state}) {
      return listRegionsGCP()
        .then(region => {
          commit('setRegionGcp', region); // Commits to new mutation
          return region;
        })
    },
  },

  mutations: {
    setUser(state, user) {
      state.userMap = {
        ...state.userMap,
        [user.userId]: user
      };
    },
    setRegion(state, regions) {
      state.listRegions = regions
    },
    setRegionGcp(state, regions) {
      state.listRegionsGcp = regions
    },
  },

  getters: {
    getUserById: (state) => (id) => {
      return state.userMap[id];
    },
    getListRegions: (state) => () => {
      if (Array.isArray(state.listRegions)) {
        return state.listRegions.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
    getListRegionsGcp: (state) => () => {
      if (Array.isArray(state.listRegionsGcp)) {
        return state.listRegionsGcp.map(region => ({
          ...region,
          label: region.displayName,
          value: region.systemName
        }));
      } else {
        return [];
      }
    },
  },

  state: defaultState(),

  modules: {
    files,
    exports,
    restores,
    backups,
    user,
  }
}
